import React from "react";
import { BsChevronDown } from "react-icons/bs";
import { daysOfWeek } from "../../../logic/calendarSettings";
import { set } from "../../../redux/features/settings/settingsSlice";
import { useDispatch, useSelector } from "react-redux/es";

const BussinessDays = () => {
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings.app);

  const boundRef = React.useRef(null);
  const pickerRef = React.useRef(null);

  const [isFocused, setIsFocused] = React.useState(false);
  const [openPicker, setOpenPicker] = React.useState(false);
  const [value, setValue] = React.useState(settings.calendarBussinesDays ?? "");
  const [selectedRow, setSelectedRow] = React.useState(settings.calendarBussinesDays ?? "");

  React.useEffect(() => {}, []);

  React.useEffect(() => {
    if (openPicker) {
      const clickListener = (e) => {
        const click = pickerRef.current.contains(e.target) || boundRef.current.contains(e.target);
        if (!click) {
          setIsFocused(false);
          setOpenPicker(false);
        }
      };
      document.addEventListener("mousedown", clickListener);
      return () => document.removeEventListener("mousedown", clickListener);
    }
  }, [openPicker]);

  const handlePicker = (e) => {
    e.stopPropagation();
    setOpenPicker((x) => !x);
    setIsFocused((x) => !x);
  };

  const handleClickOnRow = (key) => {
    const SelectedArray = selectedRow.split(",");
    if (SelectedArray.indexOf(key) >= 0) {
      SelectedArray.splice(SelectedArray.indexOf(key), 1);
    } else {
      SelectedArray.push(key);
    }
    setSelectedRow(SelectedArray.filter((x) => x != "").join(","));
    setValue(SelectedArray.filter((x) => x != "").join(","));
    dispatch(set({ key: "calendarBussinesDays", value: SelectedArray.filter((x) => x != "").join(",") }));
  };
  return (
    <div className="custom w-100" style={{ flex: `1 1 100%`, overflow: "hidden" }}>
      <div className="inputGroup">
        <label className="text-truncate">Εργάσιμες ημέρες:</label>
        <div
          ref={boundRef}
          className={`input-with-buttons${isFocused ? " underline-focus" : ""}`}
          style={{ display: "flex", flexGrow: 1, gap: "0.5rem" }}
          role="button"
        >
          <div className="d-flex w-100">
            <input
              role="button"
              style={{ backgroundColor: "transparent" }}
              className={`w-100$`}
              readOnly={true}
              value={value}
              onClick={handlePicker}
            />
          </div>
          <div
            style={{ width: "30px", display: "flex", justifyContent: "center", alignItems: "center" }}
            role="button"
            onClick={handlePicker}
          >
            <BsChevronDown color="rgb(64, 180, 252)" size="20px" />
          </div>
        </div>
      </div>
      {openPicker && (
        <div
          ref={pickerRef}
          className="input-picker-div"
          style={{
            left:
              boundRef.current.getBoundingClientRect().left + 400 > window.innerWidth
                ? boundRef.current.getBoundingClientRect().right - 400
                : boundRef.current.getBoundingClientRect().left,
            width: boundRef.current.getBoundingClientRect().width,
            top:
              boundRef.current.getBoundingClientRect().bottom -
              (boundRef.current.getBoundingClientRect().bottom + 200 > window.innerHeight
                ? 200 + boundRef.current.getBoundingClientRect().height
                : 0),
            height: "200px",
            overflow: "auto",
          }}
        >
          <table className="input-picker-table w-100">
            <tbody>
              {Object.keys(daysOfWeek).map((key) => {
                return (
                  <tr
                    key={key}
                    className={`input-picker-table-row${
                      selectedRow.split(",").indexOf(key) >= 0 ? " input-picker-table-row-selected" : ""
                    }`}
                    onClick={() => handleClickOnRow(key)}
                  >
                    <td className="p-1" style={{ height: "40px" }}>
                      {daysOfWeek[key]}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default BussinessDays;
